<template>
    <div class="blocker" v-if="state !== 'loaded'">
        <div class="spinner" v-if="state === 'loading'">
            <loading/>
        </div>
        <div class="unavailable" v-if="state === 'unavailable'">
            This module is not available at the moment.<br>
            <span class="explanation">Some modules are only available if no workflows are running.</span>
        </div>
        <div class="unavailable" v-if="state === 'unavailablePumps'">
            This module is not available at the moment.<br>
            <span class="explanation">Some modules are only available if no pump and/or workflow is running.</span>
        </div>
    </div>
</template>

<script>

export default {
    methods: {
        
    },
    components: {
        
    },
    mounted(){
        this.$modal.show('blocker');
    },
    props: [
        'state'
    ],
    data: function(){
        return {
        }
    }
}

</script>

<style lang="scss" scoped>
    @import "../colors.scss";
    .blocker {
        
        background-color: rgba(255,255,255,0.4);
        position: absolute;
        width: 100%;
        height: calc(100vh - 160px);
        z-index: 200;
        .spinner, .unavailable {
            position: fixed;
            top: calc(50vh);
            left: calc(50vw);
            transform: translate(-50%, -50%);
            vertical-align: middle;
            margin: auto;
            text-align: center;
        }
        .spinner {
            font-size: 100px;
        } 
        .unavailable {
            font-size: 2rem;
            .explanation {
                font-size: 1.5rem;
            }
        }
    }
</style>
